import React, { useState } from "react";
import HoaChoosePlan from "../HoaChoosePlan/HoaChoosePlan";

const HoaPlanModal = ({ isOpen, closeModal, handleSubmit, handleChange, newEvent, error }) => {
  return (
    <>
      {isOpen && (
        <div className="modal-overlay">
          <div className="modal">
           
<HoaChoosePlan/>
              
                  <button type="button" onClick={closeModal}>
                    Cancel
                  </button>
              
            </div>
          </div>
       
      )}
    </>
  );
};

export default HoaPlanModal;
